module.exports = __webpack_public_path__ + "img/comingsoon.878046b4.png";